import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { UserChatBubble } from '@/shared/components';
import { PayloadRenderer } from '../payload-renderer/payload-renderer';
import { BotMessage, ChatMessage, UserMessage } from '../../interfaces';

@Component({
  selector: 'bevvi-chat-message-item',
  imports: [UserChatBubble, PayloadRenderer],
  templateUrl: './chat-message-item.html',
  styleUrl: './chat-message-item.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatMessageItem {
  public readonly message = input.required<ChatMessage>();

  public readonly userReply = output<{ label: string; sourceMessageId: string }>();

  protected readonly isUserMessage = computed((): boolean => this.message().type === 'user');

  protected readonly userMessage = computed((): UserMessage | null =>
    this.message().type === 'user' ? (this.message() as UserMessage) : null,
  );

  protected readonly botMessage = computed((): BotMessage | null =>
    this.message().type === 'bot' ? (this.message() as BotMessage) : null,
  );

  protected readonly isDisabled = computed((): boolean =>
    this.message().type === 'bot' ? !!(this.message() as BotMessage).disabled : false,
  );

  public onUserReply(label: string): void {
    this.userReply.emit({ label, sourceMessageId: this.message().id });
  }
}
